import React, { useState } from 'react';
import {
  Button,
  Collapse,
  Input,
  FormControl,
  FormLabel,
  VStack,
  Box,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

import { useColors } from './colors';

const ApiConfiguration = ({
  apiId: initialApiId = '',
  apiSecret: initialApiSecret = '',
  onSave,
  updateStatus = 'idle',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [apiId, setApiId] = useState(initialApiId);
  const [apiSecret, setApiSecret] = useState(initialApiSecret);

  const { textColor, inputBackground, borderColor } = useColors();

  const handleSave = () => {
    if (onSave) {
      onSave(apiId, apiSecret);
    }
    setIsOpen(false);
  };

  return (
    <Box
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      overflow="hidden"
      bg="white"
      _dark={{ bg: 'navy.800' }}
    >
      <Button
        colorScheme="blue"
        size="md"
        width="100%"
        borderRadius="none"
        justifyContent="space-between"
        onClick={() => setIsOpen(!isOpen)}
        rightIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      >
        API configuration
      </Button>

      <Collapse in={isOpen} animateOpacity>
        <VStack spacing={4} p={4} bg={inputBackground} align="stretch">
          <FormControl>
            <FormLabel fontSize="sm" color={textColor}>
              API ID
            </FormLabel>
            <Input
              placeholder="Enter API ID"
              value={apiId}
              onChange={(e) => setApiId(e.target.value)}
              size="md"
              color={textColor}
              bg="white"
              _dark={{ bg: 'navy.900' }}
            />
          </FormControl>

          <FormControl>
            <FormLabel fontSize="sm" color={textColor}>
              API Secret
            </FormLabel>
            <Input
              placeholder="Enter API Secret"
              type="password"
              value={apiSecret}
              onChange={(e) => setApiSecret(e.target.value)}
              size="md"
              color={textColor}
              bg="white"
              _dark={{ bg: 'navy.900' }}
            />
          </FormControl>

          <Button
            colorScheme="green"
            size="md"
            width="full"
            onClick={handleSave}
            isLoading={updateStatus === 'pending'}
            loadingText="Saving…"
          >
            Save configuration
          </Button>
        </VStack>
      </Collapse>
    </Box>
  );
};

export default ApiConfiguration;
